<template>
  <div class="page-header p-3 mb-3">
    <h1 class="page-title">{{ title }}</h1>
    <div class="action-wrapper">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PageTitle',
  components: {},
  props: {
    title: {
      type: String,
      required: true,
    },
  },
});
</script>
<style>
.page-header {
  background: var(--background-level-2);
  min-height: 62px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.page-title {
  font-size: 1.4rem;
  font-weight: 400;
  color: var(--primary);
  margin: 0;
}

.action-wrapper > *:not(:first-child) {
  margin-left: 0.5em;
}
</style>
